import { render, staticRenderFns } from "./radios-mobile.vue?vue&type=template&id=f666d76c"
import script from "./radios-mobile.vue?vue&type=script&lang=ts"
export * from "./radios-mobile.vue?vue&type=script&lang=ts"
import style0 from "./radios-mobile.vue?vue&type=style&index=0&id=f666d76c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports